import axios from "axios";

// The reads of the slice 2 member screen (snb_lightspeed_backend
// docs/customer-module/kyc/13-Slice-2-Full-Replacement.md §4, "Members
// (read)"). Every action commits the whole envelope and returns it. These are
// customer journey routes: errors carry their details under `data`.
export default {
    namespaced: true,

    state: {
        profile: null,
        documents: null,
        group_members: null,
    },

    getters: {
        profile(state) {
            return state.profile;
        },
        documents(state) {
            return state.documents;
        },
        groupMembers(state) {
            return state.group_members;
        },
    },

    mutations: {
        SET_PROFILE(state, profile) {
            return (state.profile = profile);
        },
        SET_DOCUMENTS(state, documents) {
            return (state.documents = documents);
        },
        SET_GROUP_MEMBERS(state, groupMembers) {
            return (state.group_members = groupMembers);
        },
    },

    actions: {
        // GET /customers/{id}/profile: the member's values by section,
        // pending_values and open_change_request
        async fetchProfile({ commit }, customerId) {
            return await axios
                .get(`/api/v1/customers/${customerId}/profile`)
                .then((res) => {
                    commit("SET_PROFILE", res.data);
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        // GET /customers/{id}/documents: one entry per applicable type, the
        // current version masked, and `pending` for a version in an open request
        async fetchDocuments({ commit }, customerId) {
            return await axios
                .get(`/api/v1/customers/${customerId}/documents`)
                .then((res) => {
                    const envelope = { ...res.data, data: res.data?.data ?? [] };
                    commit("SET_DOCUMENTS", envelope);
                    return envelope;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        // GET /customers/{id}/group-members: the group's current member set
        async fetchGroupMembers({ commit }, customerId) {
            return await axios
                .get(`/api/v1/customers/${customerId}/group-members`)
                .then((res) => {
                    commit("SET_GROUP_MEMBERS", res.data);
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },
    },
};
